<template>
	<div>
		<el-card class="box-card" shadow="never">
			<div slot="header" class="clearfix">
				<span>權限管理</span>
				<el-button class="createBtn" type="primary" v-has="'addRule'" @click="showCreate"><i class="el-icon-plus"></i>新增</el-button>
			</div>
			<div>
				<div class="mr-t15">
					<el-table v-loading="loading" :data="dataList" style="width: 100%;margin-bottom: 20px;" row-key="id" border
						default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
						<el-table-column prop="rule_name" label="權限名稱" width="200"></el-table-column>
						<el-table-column prop="type" align="center" width="120" label="類型">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.type==1" type="primary">菜單</el-tag>
								<el-tag v-if="scope.row.type==2" type="warning">方法</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="module" label="模塊"></el-table-column>
						<el-table-column prop="controller" label="控制器"></el-table-column>
						<el-table-column prop="action" label="方法"></el-table-column>
						<el-table-column prop="path" label="頁面路徑"></el-table-column>
						<el-table-column prop="node" label="權限代碼"></el-table-column>
						<el-table-column prop="icon" label="圖標" width="150" align="center">
							<template slot-scope="scope">
								<i style="font-size: 16px;" :class="scope.row.icon"></i>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="260" align="center">
							<template slot-scope="scope">
								<div class="flex flex-row-center">
									<div>
										<el-button size="mini" type="primary" v-has="'updateRule'" @click="edit(scope.row)">修改</el-button>
									</div>
									<div class="mr-l15">
										<el-button size="mini" type="danger" v-has="'delRule'" @click="del(scope.row)">删除</el-button>
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<!-- 新增-->
				<RuleCreateModal @success="createSuccess" :dialogVisible="createDialogVisible" @close="createDialogClose"></RuleCreateModal>

				<!-- 修改 -->
				<RuleEditModal @ok="editOk" ref="editModal" :dialogVisible="editDialogVisible" @close="editDialogClose"></RuleEditModal>

			</div>
		</el-card>
	</div>
</template>

<script>
	import RuleCreateModal from "@/views/settings/rule/RuleCreateModal"
	import RuleEditModal from "@/views/settings/rule/RuleEditModal"
	export default {
		name: "RuleList",
		components: {
			RuleCreateModal,
			RuleEditModal,
		},
		data() {
			return {
				loading: true,
				dataList: [],
				createDialogVisible: false,
				editDialogVisible: false,
			}
		},
		created() {
			this.getRuleList();
		},
		methods: {
			//显示新增dialog
			showCreate() {
				this.createDialogVisible = true;
			},
			//关闭新增dialog
			createDialogClose() {
				this.createDialogVisible = false;
			},
			//传值并且打开修改dialog
			edit(row) {
				this.$refs.editModal.getData(row);
				this.editDialogVisible = true;
			},
			//关闭修改dialog
			editDialogClose() {
				this.editDialogVisible = false;
			},
			setDialogClose() {
				this.setDialogVisible = false;
			},
			statusChange(row) {
				this.$request({
					url: this.$api.role.updateStatus,
					method: "post",
					data: {
						id: row.id,
						status: row.status
					}
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg)
					} else {
						this.$message.error(res.data.msg)
					}
				}).catch(() => {
					this.$message.error("请求失败");
				})
			},
			createSuccess() {
				this.createDialogVisible = false;
				this.getRuleList();
			},
			editOk() {
				this.editDialogVisible = false;
				this.getRuleList();
			},
			//删除
			del(row) {
				this.$confirm('此操作將永久刪除，是否繼續?', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$request({
						url: this.$api.rules.del,
						method: "post",
						data: {
							id: row.id
						}
					}).then((res) => {
						if (res.data.code == 1) {
							this.$message.success(res.data.msg);
							this.getRuleList();
						} else {
							this.$message.error(res.data.msg);
						}
					}).catch(() => {
						this.$message.error("请求失败");
					})
				}).catch(() => {

				});
			},
			//获取列表
			getRuleList() {
				this.loading = true;
				this.$request({
					url: this.$api.rules.getAllRuleList,
				}).then((res) => {
					if(res.data.code==1){
						this.dataList = res.data.data;
						this.loading = false;
					}else{
						this.$message.error(res.data.msg);
					}
				}).catch(() => {
					this.$message.error("获取列表失败");
				})
			},
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/rule/RuleList.vue